const routes = {
  '/': 'Home',
  '/base': 'Base',
  '/base/cards': 'Cards',
  '/base/forms': 'Forms',
  '/base/switches': 'Switches',
  '/base/tables': 'Tables',
  '/base/tabs': 'Tabs',
  '/base/breadcrumbs': 'Breadcrumbs',
  '/base/carousels': 'Carousels',
  '/base/collapses': 'Collapses',
  '/base/jumbotrons': 'Jumbotrons',
  '/base/list-groups': 'List Groups',
  '/base/navbars': 'Navbars',
  '/base/navs': 'Navs',
  '/base/paginations': 'Paginations',
  '/base/popovers': 'Popovers',
  '/base/progress-bar': 'Progress Bar',
  '/base/tooltips': 'Tooltips',
  '/buttons': 'Buttons',
  '/buttons/buttons': 'Buttons',
  '/buttons/social-buttons': 'Social Buttons',
  '/buttons/button-dropdowns': 'Button Dropdowns',
  '/buttons/button-groups': 'Button Groups',
  '/charts': 'Charts',
  '/dashboard': 'Dashboard',
  '/icons': 'Icons',
  '/icons/flags': 'Flags',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',
  '/notifications': 'Notifications',
  '/notifications/alerts': 'Alerts',
  '/notifications/badges': 'Badges',
  '/notifications/modals': 'Modals',
  '/theme': 'Theme',
  '/theme/colors': 'Colors',
  '/theme/typography': 'Typography',
  '/vehicle': 'Vehicle',
  '/widgets': 'Widgets'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js